import { render, staticRenderFns } from "./InvoiceStatusForm.vue?vue&type=template&id=1b1d00ed&"
import script from "./InvoiceStatusForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports